import {
  buildMeasureOption,
  buildQrCodeOption,
  HasMeasureContext,
  HasQrCodeContext,
} from '@components/map/contextMenu/builders/common';
import { createContextMenuDynamicOptions } from '@components/map/contextMenu/builders/utils';
import { FeatureTypeToContextComponentEnum, MenuBuilder, MenuKey } from '@components/map/contextMenu/type';

import { MapIdEnum, OperationalMapId } from '@/types/map.types';
import { MenuItemOption } from '@/types/menu.types';

export type ReplayEventContextCore = {
  handleUpdateReplayEvent: () => void;
};

export type ReplayEventContextMenuContext = HasQrCodeContext & HasMeasureContext & ReplayEventContextCore;

export type ReplayEventContextMenuDynamicOptions = {
  updateReplayEvent: boolean;
};

export type ReplayEventContextMenuOptions = ReplayEventContextMenuDynamicOptions;

export const REPLAY_EVENT_DEFAULT_CONTEXT_MENU_DYNAMIC_OPTIONS: ReplayEventContextMenuDynamicOptions = {
  updateReplayEvent: true,
};

const allTrue = createContextMenuDynamicOptions(REPLAY_EVENT_DEFAULT_CONTEXT_MENU_DYNAMIC_OPTIONS, true);
const allFalse = createContextMenuDynamicOptions(REPLAY_EVENT_DEFAULT_CONTEXT_MENU_DYNAMIC_OPTIONS, false);

export const replayEventContextMenuConfig: Record<OperationalMapId, ReplayEventContextMenuDynamicOptions> = {
  [MapIdEnum.LIVE]: allTrue,
  [MapIdEnum.LAD]: allTrue,
  [MapIdEnum.REPLAY]: allFalse,
  [MapIdEnum.STATISTICS]: allFalse,
};

const buildUpdateReplayEventOption: MenuBuilder<FeatureTypeToContextComponentEnum.REPLAY_EVENT>['build'] = (
  ctx,
): [MenuKey, MenuItemOption] => [
  'updateReplayEvent',
  {
    label: 'contextmenu.actions.updateEvent',
    onAction: ctx.handleUpdateReplayEvent,
  },
];

export const replayEventBuilders: MenuBuilder<FeatureTypeToContextComponentEnum.REPLAY_EVENT>[] = [
  {
    order: 1,
    build: buildUpdateReplayEventOption,
  },
  {
    order: 2,
    build: buildQrCodeOption,
  },
  {
    order: 3,
    build: buildMeasureOption,
  },
];
